module.exports = __webpack_public_path__ + "static/media/Electrodes_vet_crabs.1ac69851.png";